import WorldPinImage from '@shared/assets/images/v2/world-pin.svg';
import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { MBButton } from '@shared/components/MBButton';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  anchorName: string;
  onClose(): void;
  onPress(): void;
}

export function PromptBottomSheetContent({ anchorName, onPress, onClose }: Props) {
  return (
    <AnchoredSheet
      anchorName={anchorName}
      title={i18n('card.blocks.geolocationInput.prompt.title')}
      onClose={onClose}
    >
      <View padding={4} style={{ width: 320, alignSelf: 'center' }}>
        <Text size="body1" align="center">
          {i18n('card.blocks.geolocationInput.prompt.description')}
        </Text>
        <View paddingTop={4} />
        <MBImage
          source={WorldPinImage}
          style={{ height: grid(12), width: '100%' }}
          resizeMode="contain"
        />
        <View paddingTop={4} />
        <MBButton title={i18n('card.blocks.geolocationInput.prompt.cta')} onPress={onPress} />
      </View>
    </AnchoredSheet>
  );
}
